import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    warningContainer: {
        padding: theme.spacing(2),
        borderRadius: 10,
        maxWidth: 165,
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "center",
        justifyContent: "flex-start",
    },
    warningTitle: {
        color: theme.palette.warning.main,
        fontSize: `10px !important`,
        textAlign: "left",
    },
    icon: {
        color: `${theme.palette.warning.main} !important`,
        width: "26px !important",
        height: "26px !important",
    },
}));
